export default __webpack_public_path__ + "static/media/3.2cbe0483.jpg";